export default __webpack_public_path__ + "static/312-344e24721ef4cb83324141441fb77cb8.gif";